import Vue from 'vue';
import basketMixin from '../core/basket'
import utils from '../core/core'
import wishlistMixin from '../core/wishlist'
import { Fancybox } from "@fancyapps/ui";


// components
import productSlider from '../components/product-slider'
import productAutocomplete from '../components/product-autocomplete'
import cityAutocomplete from '../components/city-autocomplete'

Vue.component('product-slider', productSlider);
Vue.component('product-autocomplete', productAutocomplete);
Vue.component('city-autocomplete', cityAutocomplete);

var mainVM = new Vue({
    mixins: [basketMixin, wishlistMixin],
    el: '#mainApp'
});

window.utils = utils;

$(document).on("click", ".share-panel .trigger", function () {
    console.log($('.popover-markup').length);
    if ($('.popover-markup').hasClass('active')) {
        $('.popover-markup').hide(300);
        $('.popover-markup').removeClass('active');
    } else {
        $('.popover-markup').show(300);
        $('.popover-markup').addClass('active');
    }
});

$(document).on("click", "#main-pic", function (e) {
    var clickedImgSrc = $(e.target).attr("src");
    if (clickedImgSrc != undefined && clickedImgSrc.length > 0) {
        var srcParts = clickedImgSrc.split("/");
        var picName = srcParts[srcParts.length - 1];
        var relevantImgElement = $(".more-pics .fancybox-item img[src*='" + picName + "']")[0];
        //$(relevantImgElement).closest(".fancybox-item").trigger("click");
        var el = $(relevantImgElement).closest(".fancybox-item");
        if (el.length> 0)
            el[0].click();
    }
    else {
        //can not find relevant picture --> trigger fancybox with first pic (if we have any)
        var fancyElements = $(".more-pics .fancybox-item");
        if (fancyElements.length > 0)
            $(fancyElements[0]).trigger("click");
    }
});

$(document).on('click', '.options .option', function (event) {
    //event.preventDefault();
    var curOption = $(this);
    $('.options .option').removeClass('active');
    $('#basket-btn').attr('basket-variant-id', curOption.attr('data-productid'));
    $('#basicPrice').html(formatCurrency(curOption.attr('data-price'), 2).replace("₪", "<small>₪</small>"));
    if (curOption.attr('data-weight-unit')) {
        $('#byKgPrice').html(formatCurrency(curOption.attr('data-unit-price'), 2) + " מחיר ל" + curOption.attr('data-weight-unit'));
    }
    if (curOption.attr('data-weight') && curOption.attr('data-weight') != '') {
        $('.prWeight').html(curOption.attr('data-weight'));
    }
    curOption.addClass('active');

    var slideItem = $('[data-varid="' + curOption.attr('data-productid') + '"]');
    if (slideItem.length > 0) {
        //$('#carousel-example-generic').data("bs.carousel").to(slideItem.attr('data-count'));
        $('#ProductCarousel').carousel(parseInt(slideItem.attr('data-count')));
    }
});

function formatCurrency(value, toFixed, SliderMeasurement) {
    if (!SliderMeasurement) { SliderMeasurement = '₪'; }
    return SliderMeasurement + parseFloat(value)
        .toFixed(toFixed && toFixed > 0 ? toFixed : 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}